import { useState } from "react";

import type { CO2Rating, NutritionalInformation } from "~/api/products/types";
import { Modal } from "~/components/kiosk/ui/modals/shared/modal";

import { NutritionClimateRow } from "./nutrition-climate-row";
import { hasNutritionClimate } from "./nutrition-climate-utils";
import { NutritionDetailPanel } from "./nutrition-detail-panel";

type KioskNutritionSectionProps = {
  nutrition: NutritionalInformation | null;
  co2Rating: CO2Rating | null;
};

/**
 * The "Nutrition & climate" section of the kiosk product detail card: the inline
 * row plus the full-nutrition modal it opens, with the modal's open state owned
 * here. Renders nothing when the product has neither nutrient values nor a
 * climate grade.
 */
export const KioskNutritionSection = ({
  nutrition,
  co2Rating
}: KioskNutritionSectionProps) => {
  const [showNutrition, setShowNutrition] = useState(false);

  if (!hasNutritionClimate(nutrition, co2Rating)) return null;

  const openNutrition = () => {
    setShowNutrition(true);
  };
  const closeNutrition = () => {
    setShowNutrition(false);
  };

  return (
    <>
      <div className="border-b px-10 pb-8">
        <NutritionClimateRow
          nutrition={nutrition}
          co2Rating={co2Rating}
          onOpenFullNutrition={openNutrition}
        />
      </div>

      {showNutrition && nutrition ? (
        <Modal backdropVariant="idle" onOutsideClick={closeNutrition}>
          <div className="w-[600px] overflow-hidden rounded-[24px] bg-white shadow-[0px_24px_60px_-12px_rgba(0,0,0,0.35)]">
            <NutritionDetailPanel
              nutrition={nutrition}
              onClose={closeNutrition}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};
